// polyfill only stable `core-js` features - ES and web standards:
import { CircularProgress } from '@mui/material';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import ConfigProvider from './components/ConfigProvider';
import ReactQueryProvider from './components/ReactQueryProvider';
import Routes from './containers/Routes';
import './index.css';
import { initializeKeycloak } from './services/Authentification/authentification';
import * as serviceWorker from './serviceWorker';
import theme from './theme';
import { ThemeProvider } from '@mui/styles';

const handleConfigLoaded = () => {
  initializeKeycloak();
};

// Locale par defaut : FR

const MOUNT_NODE = document.getElementById('root') as HTMLElement;
const root = createRoot(MOUNT_NODE);
root.render(
  // tslint:disable-next-line: jsx-wrap-multiline
  <ConfigProvider onLoad={handleConfigLoaded} loading={<CircularProgress />}>
    <ReactQueryProvider>
      <ThemeProvider theme={theme}>
        <CookiesProvider>
          <Routes />
        </CookiesProvider>
      </ThemeProvider>
    </ReactQueryProvider>
  </ConfigProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
